<template>
  <q-page-container>
    <q-page>
      <section class="page-container-form">
        <q-option-group
          hidden
          v-model="panel"
          inline
          :options="panelList"
        />
        <q-tab-panels
          v-model="panel"
          class="panel-services-form"
        >
          <q-tab-panel
            class="panel-item-form q-py-lg"
            v-for="panelItem in formList"
            :key="panelItem.labelTab"
            :name="panelItem.labelTab"
          >
            <component
              ref="tabFormRef"
              :itemOsContract="schemeSolicitation"
              :typeOs="attendanceOption"
              :is="panelItem.component"
              :contract="formScheme"
              :optionsItens="optionsItens"
              @disabledtabButton="(value) => disabledtabButton(value)"
              @update-city="(city) => getCityDetailsByCode(city)"
            />
          </q-tab-panel>
        </q-tab-panels>
        <div>
          <FooterToolbar
            v-if="isShowProgressBar"
            :progressBarValue="progressBar"
            :maxValue="VALUE_MAX_BAR_PROGRESS"
            :finishFn="finishAttendance"
            :nextTabFn="addValueBarProgressAndAlterTab"
            :isLoading="isLoading"
          />
        </div>
      </section>
    </q-page>
  </q-page-container>
</template>

<script>
  import AttendanceClock from "@/components/AttendanceClock.vue";
import ContractData from "@/components/generatedOsForm/ContractData.vue";
import TechnicianData from "@/components/generatedOsForm/TechnicianData.vue";
import ContractForm from "@/components/SpecialCodes/ContractForm.vue";
import FooterToolbar from "@/components/SpecialCodes/FooterToolbar.vue";
import ServiceInfoForm from "@/components/SpecialCodes/ServiceInfoForm.vue";
import SolicitationList from "@/components/SpecialCodes/SolicitationList.vue";
import TechnicianForm from "@/components/SpecialCodes/TechnicianForm.vue";
import SpecialCodeService from "@/services/SpecialCodesService";
import generateUUIDv4 from "@/utils/generetaUUID.js";
import createJsonSpecialCodes from "@/utils/ResquestOsForms/createJsonSpecialCodes";
import moment from "moment-timezone";

  import { useQuasar } from "quasar";
import { onBeforeMount, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

  export default {
    name: "GenerateFormSpecialCodes",
    components: {
      ContractData,
      AttendanceClock,
      SolicitationList,
      TechnicianData,
      ContractForm,
      TechnicianForm,
      SolicitationList,
      ServiceInfoForm,
      FooterToolbar,
    },
    setup() {
      const $q = useQuasar();
      const route = useRoute();
      const router = useRouter();

      const specialCodeService = new SpecialCodeService();

      const optionsItens = reactive({
        optionsAccredited: [],
        optionsCity: [],
        optionsCodCity: [],
        optionsTypeOS: [],
        optionsWriteOffCode: [],
        optionsActionOs: [],
        optionsStates: [],
        optionsInstallationImpediments: [],
      });
      const store = useStore();

      let formScheme = ref({
        accredited: "",
        numberPhone: "",
        contractNumber: "",
        optionsAccredited: "",
        codeCity: null,
        city: null,
        contractOs: null,
        dateStartedAttendance: moment().tz("America/Sao_Paulo").format("YYYY-MM-DD HH:mm:ss"),
        dateFinishedAttendance: moment().tz("America/Sao_Paulo").format("YYYY-MM-DD HH:mm:ss"),
        solicitations: [],
        conclusionTime: "",
        initialTime: "",
        isOwnTechnician: true,
        technicianCode: "",
        accreditedCode: "",
      });

      const formList = ref([
        { labelTab: "tab-1", component: TechnicianForm },
        { labelTab: "tab-2", component: ContractForm },
        { labelTab: "tab-3", component: SolicitationList },
        { labelTab: "tab-4", component: AttendanceClock },
      ]);

      const panelList = formList.value.map((tab, index) => ({
        label: `Tarefb-${index + 1}`,
        value: `tab-${index + 1}`,
      }));

      let panel = ref("tab-1");
      let progressBar = ref(0);
      let isShowProgressBar = ref(true);

      let schemeSolicitation = {
        object_id: generateUUIDv4(),
        osNumber: "",
        typeOS: null,
        writeOffCode: null,
        action: null,
        observation: "",
        equipamentNumberInstall: "",
      };

      let tabFormRef = ref(null);
      let attendanceOption = ref({});
      let isLoading = ref(false);

      const VALUE_MAX_BAR_PROGRESS = 1;
      const VALUE_ADD_PROGRESS = 1 / formList.value.length;

      let increaseProgressBar = () => (progressBar.value += VALUE_ADD_PROGRESS);

      let toggleLoading = () => (isLoading.value = !isLoading.value);

      const disabledtabButton = (value) => (isShowProgressBar.value = value);

      async function getCitiesActives() {
        await specialCodeService.getCitiesActives().then((response) => {
          optionsItens.optionsCity = response;
          optionsItens.optionsCodCity = response;
        });
      }

      function getNextProgressPageNumber() {
        let panelSplited = panel.value.split("-");

        return parseInt(panelSplited.slice(-1).pop(), 10) + 1;
      }

      function setPanelTab() {
        let number = getNextProgressPageNumber();
        panel.value = `tab-${number}`;
      }

      function showNotifyError(message) {
        $q.notify({
          message: message,
          color: "red-9",
          position: "top",
        });
      }

      async function addValueBarProgressAndAlterTab() {
        if (panel.value === "tab-3") {
          let isFormFilled = formScheme.value.solicitations[0].isFilled;

          if (isFormFilled) {
            setPanelTab();
            increaseProgressBar();
            return;
          } else {
            showNotifyError("Você tem que preencher uma solicitacão");
            return;
          }
        }

        if (await tabFormRef.value[0].validateForm()) {
          setPanelTab();

          if (progressBar.value != VALUE_MAX_BAR_PROGRESS) {
            increaseProgressBar();
          }
        }
      }

      function redirectToHistoryPage() {
        let token = localStorage.getItem("access_token");
        router.replace({
          name: "service-history",
          query: { access_token: token },
        });
      }

      async function createSpecialCodeOs(payload) {
        await specialCodeService
          .saveSpecialCode(payload)
          .then((response) => {
            redirectToHistoryPage();
            toggleLoading();
          })
          .catch((err) => {
            console.log(err)
            toggleLoading();
            showNotifyError("Erro ao gerar OS. Por favor refaça o formulário.");
          });
      }

      async function finishAttendance() {
        let isSolicitationTab = panel.value == "tab-3";
        let isSolicitationFormFilled =
          formScheme.value.solicitations[0].isFilled == true;

        if (isSolicitationTab) {
          if (!isSolicitationFormFilled) {
            showNotifyError("Você tem que preencher uma solicitacão");
            return;
          }
        }

        let isFormValid = await tabFormRef.value[0].validateForm();

        if (isFormValid) {
          let jsonPayload = createJsonSpecialCodes(formScheme.value);

          jsonPayload.osRequests[0].IdServiceOption = parseInt(
            route.params.os_type
          );
          toggleLoading();
          createSpecialCodeOs(jsonPayload);
        }
      }

      function getAccreditedsActives() {
        specialCodeService.getAccreditedsActives().then((response) => {
          optionsItens.optionsAccredited = response;
        });
      }

      function getDefaultTechnicianData() {
        formScheme.value.accredited = store.state.accredited;
        formScheme.value.numberPhone = store.state.numberPhone;
        if (store.state.addressCity != "") {
          specialCodeService
            .getCodeCityByName(store.state.addressCity)
            .then((response) => {
              formScheme.codeCity = {
                text: response.cidade,
                value: response.codcidadenetsms,
              };
              formScheme.city = {
                text: response.cidade,
                value: response.codcidadenetsms,
              };
            });
        }
      }

      function getAllActions() {
        specialCodeService.getAllActions().then((response) => {
          optionsItens.optionsActionOs = response;
        });
      }

      function getWriteOffCode() {
        specialCodeService
          .getWriteOffCodeByOption(attendanceOption.value.os_type)
          .then((response) => {
            optionsItens.optionsWriteOffCode = response;
          });
      }

      function getTypeOsOptions() {
        specialCodeService
          .getTypeOsByServiceOption(attendanceOption.value.os_type)
          .then((response) => {
            optionsItens.optionsTypeOS = response;
          });
      }

      function getStatesOptions() {
        specialCodeService.getAllStateEquipaments().then((response) => {
          optionsItens.optionsStates = response;
        });
      }

      function getInstallationImpediments() {
        specialCodeService.getInstallationImpedimentList().then((response) => {
          optionsItens.optionsInstallationImpediments = response;
        });
      }

      async function getCityDetailsByCode(city) {
        const { atendimento, profile } =
          await specialCodeService.getCityByCodeCity(city.value);
        formScheme.value.city = {
          ...city,
          atendimento,
          profile,
        };
      }

      const setInitialProgressBarValue = () =>
        (progressBar.value = 1 / formList.value.length);

      const fetchInitialData = async () => {
        getDefaultTechnicianData();
        getAccreditedsActives();
        getCitiesActives();
        getAllActions();
        getWriteOffCode();
        getTypeOsOptions();
        getStatesOptions();
        getInstallationImpediments();
      };

      onBeforeMount(() => {
        attendanceOption.value = route.params;
        fetchInitialData();
        setInitialProgressBarValue();
      });

      return {
        ContractData,
        AttendanceClock,
        formList,
        panelList,
        panel,
        formScheme,
        optionsItens,
        VALUE_MAX_BAR_PROGRESS,
        progressBar,
        isShowProgressBar,
        schemeSolicitation,
        tabFormRef,
        attendanceOption,
        disabledtabButton,
        addValueBarProgressAndAlterTab,
        finishAttendance,
        isLoading,
        fetchInitialData,
        getCityDetailsByCode,
      };
    },
  };
</script>

<style lang="scss">
  html {
    ::-webkit-scrollbar {
      width: 7px;
      height: 7px;
    }

    ::-webkit-scrollbar-track-piece {
      background-color: transparent;
      -webkit-border-radius: 6px;
    }

    ::-webkit-scrollbar-thumb:vertical {
      background-color: #cccccc;
      -webkit-border-radius: 6px;
    }
  }

  .page-container-form {
    display: flex;
    width: 100%;
    padding-bottom: 0px;
  }
  .panel-services-form {
    background: transparent !important;
    overflow: hidden !important;
    display: flex;
    width: 100%;
    height: 90%;

    .panel-item-form {
      width: 100%;
      padding: 20px;
      height: 100%;
    }
  }

  .title-page-form {
    font-weight: bold;
    font-size: 18px;
    line-height: 19px;
    text-transform: uppercase;
    color: #e2262d;
  }
</style>
